module.exports = __webpack_public_path__ + "static/image_5-22caf8a54aab0248f5058cc385f8dc13.jpg";